import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import DictionariesRateUpdateModel from "../../../viewModels/Dictionaries/DictionariesRateUpdateModel";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  ratesUpdate: Array<DictionariesRateUpdateModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;
} = {
  loading: true,
  loadingData: true,

  ratesUpdate: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,
};

const dictionariesRatesUpdateSlice = createSlice({
  name: "dictionariesRatesUpdate",
  initialState,
  reducers: {
    loadRatesUpdate(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadRatesUpdateSuccess(state, action: PayloadAction<{ ratesUpdate: Array<DictionariesRateUpdateModel>; total: number }>) {
      const { ratesUpdate, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.ratesUpdate = ratesUpdate;
      state.total = total;
    },
    loadRatesUpdateError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
  },
});

export default dictionariesRatesUpdateSlice;
